import { isProductionMode, isProductionModeSync } from "./environment";

type PasswordAuthMode = "auto" | "enabled" | "disabled";

function normalizePasswordAuthMode(rawMode: string | undefined): PasswordAuthMode {
  if (rawMode === "enabled" || rawMode === "disabled") {
    return rawMode;
  }
  return "auto";
}

export function isPasswordAuthAllowedForProductionMode(
  productionMode: boolean,
  rawMode = import.meta.env.VITE_PASSWORD_AUTH_MODE,
): boolean {
  const mode = normalizePasswordAuthMode(rawMode);

  if (mode === "enabled") return true;
  if (mode === "disabled") return false;

  return !productionMode;
}

export async function isPasswordAuthAllowed(): Promise<boolean> {
  const productionMode = await isProductionMode();
  return isPasswordAuthAllowedForProductionMode(productionMode);
}

export function isPasswordAuthAllowedSync(): boolean {
  return isPasswordAuthAllowedForProductionMode(isProductionModeSync());
}

export function isLocalOidcRoundtripAllowed(
  supabaseUrl = import.meta.env.VITE_SUPABASE_URL,
): boolean {
  return (supabaseUrl ?? "").includes("127.0.0.1");
}
